import queryClient from "@/utils/queryClient";
import { currentNotificationSettingsKeys, smsCategoriesKeys, termsAndConditionsAcceptanceStatusKeys, } from "@/utils/queryKeyFactories";
import { removeAlreadyAskedForSMSConsent } from "@/components/ConsentModal/utils/storage";
export const removeTermsAndConditionsQueries = () => {
    queryClient.removeQueries({ queryKey: termsAndConditionsAcceptanceStatusKeys.all() });
    queryClient.removeQueries({ queryKey: smsCategoriesKeys.all() });
    queryClient.removeQueries({ queryKey: currentNotificationSettingsKeys.all() });
    removeAlreadyAskedForSMSConsent();
};
